import DataConfirmation from "./DataConfirmation";
import DataError from "./DataError";
import DataRun from "./DataRuns";
class DataValidation {
    confirmation;
    errors;
    runs;
    constructor(response) {
        this.confirmation = response.confirmation !== undefined ? new DataConfirmation(response.confirmation) : undefined;
        this.errors = response.errors !== undefined ? response.errors.map(e => new DataError(e)) : undefined;
        this.runs = response.runs !== undefined ? response.runs.map(e => new DataRun(e)) : undefined;
    }
    toResponse() {
        return {
            confirmation: this.confirmation?.toResponse(),
            errors: this.errors?.map(e => e.toResponse()),
            runs: this.runs?.map(r => r.toResponse())
        };
    }
}
export default DataValidation;
